import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {Link} from '../../link/link';
import {Body} from '../../typography/body';

export const copy = {
    all: {
        header: 'All integrations',
        body: (
            <Body>
                Nutshell integrates with over 50 different best-in-class products out of the box,
                and even more with our own custom integration offering. Can’t find the product
                you’re looking for? Visit our {/* @ts-expect-error */}
                <Link as={RoutedLink} variant='primary' to='/setup/integration/custom-quote'>
                    Custom quote
                </Link>{' '}
                page to get started.
            </Body>
        ),
    },
    accounting: {
        header: 'Accounting',
        body: 'AppConnect allows you to sync customer data between your accounting software and CRM, so you can track interactions and keep all your data updated. That way, your CRM becomes a single source of truth for your organization. Integrating your accounting software and CRM software also cuts back on manual data entry and simplifies tasks like adding and updating contacts and leads, saving your team time and improving efficiency.',
    },
    collaboration: {
        header: 'Collaboration',
        body: 'Staying connected with your team keeps everyone on the same page and helps you streamline your workflows for more efficiency. Collaboration tools are especially important when it comes to developing customer relationships, so you can avoid things like sending the same marketing email to a prospect three weeks in a row.',
    },
    communication: {
        header: 'Communication & phone',
        body: 'Integrating your communication platforms with your CRM is a great way to keep track of your communications in a central location. That way you can update your colleagues on communications with clients and keep a record of every customer interaction — all so you can better nourish relationships and make more sales.',
    },
    contracts: {
        header: 'Contracts & proposals',
        body: 'Integrating your contract and proposal applications with your CRM is the solution to organizing your essential documents. Your team can attach proposals and other important documents to the right customer or lead’s page in the CRM, making it easy to find what you need to move a sale forward — or nurture an existing relationship.',
    },
    forms: {
        header: 'Forms',
        body: 'One of the best ways to manage the information you gather from web forms is with a web form CRM integration. By integrating your web form applications with your CRM, you can seamlessly track submissions and connect information with your contacts to strengthen your relationships.',
    },
    lead_generation: {
        header: 'Lead generation',
        body: 'Nutshell offers several lead generation and prospecting CRM integrations for whatever way your organization prefers to drive more leads to your business. Together, Nutshell and lead generation are pretty powerful.',
    },
    scheduling: {
        header: 'Scheduling',
        body: 'AppConnect allows you to sync customer data between your scheduling software and CRM, so you can track interactions and keep all your data updated. That way, your CRM becomes a single source of truth for your organization. Integrating your scheduling software and CRM software also cuts back on manual data entry and simplifies tasks like activity logging, saving your team time and improving efficiency.',
    },
    webinars: {
        header: 'Webinars',
        body: 'AppConnect allows you to sync customer data between your webinar and event software and CRM, so you can track interactions and keep all your data updated. That way, your CRM becomes a single source of truth for your organization. Integrating your webinar and event software and CRM software also cuts back on manual data entry and simplifies tasks like adding and updating contacts and leads, saving your team time and improving efficiency.',
    },
    other: {
        header: 'Other',
        body: 'Nutshell integrates with over 50 different best-in-class products out of the box, and even more with our own custom integration offering. Not seeing the product you need- fill out a custom quote form below.',
    },
} as const;

export const NUTSHELL_FEATURE_MAP = {
    'Click-to-call': {
        learnMoreLink:
            'https://support.nutshell.com/en/articles/8428904-phone-setting-up-click-to-call',
        featureLink: '/my-account/phone',
        featureDisplayText: 'Nutshell’s Click-to-call feature',
    },
    'Phone integrations': {
        learnMoreLink: 'https://support.nutshell.com/en/collections/11432707-communication-phone',
        featureLink: '/my-account/phone',
        featureDisplayText: 'Nutshell’s Phone integrations',
    },
    'Nutshell SMS': {
        learnMoreLink:
            'https://support.nutshell.com/en/articles/9674420-nutshell-sms-how-to-send-and-manage-texts',
        featureLink: '/inbox/sms',
        featureDisplayText: 'Nutshell SMS',
    },
    'SMS marketing': {
        learnMoreLink:
            'https://support.nutshell.com/en/articles/10429742-how-to-send-bulk-sms-and-set-up-automated-sms-drip-sequences',
        featureLink: '/marketing/sms',
        featureDisplayText: 'Nutshell’s SMS marketing tool',
    },
    'Nutshell Quotes & Invoices': {
        learnMoreLink: 'https://support.nutshell.com/en/articles/10616834-nutshell-quotes-guide',
        featureLink: '/sales/quote-template',
        featureDisplayText: 'Nutshell Quotes & Invoices',
    },
    'Nutshell Scheduler': {
        learnMoreLink:
            'https://support.nutshell.com/en/articles/8428989-scheduler-plan-schedule-and-manage-meetings',
        featureLink: '/sales/scheduler',
        featureDisplayText: 'Nutshell Scheduler',
    },
    'Landing pages': {
        learnMoreLink:
            'https://support.nutshell.com/en/articles/8790094-landing-pages-create-effective-landing-pages',
        featureLink: '/marketing/landing-pages',
        featureDisplayText: 'Nutshell Landing pages',
    },
    'Nutshell Forms': {
        learnMoreLink:
            'https://support.nutshell.com/en/articles/8429028-nutshell-forms-create-forms-for-your-website',
        featureLink: '/marketing/forms',
        featureDisplayText: 'Nutshell Forms',
    },
    ProspectorIQ: {
        learnMoreLink:
            'https://support.nutshell.com/en/articles/9669692-prospectoriq-find-leads-that-match-your-icp',
        featureLink: '/sales/prospectoriq',
        featureDisplayText: 'ProspectorIQ',
    },
    'Email marketing': {
        learnMoreLink: 'https://support.nutshell.com/en/collections/11433350-email-marketing',
        featureLink: '/marketing/email',
        featureDisplayText: 'Nutshell’s Email marketing tool',
    },
} as const;
